/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useMemo, useRef } from 'react'
import { useDrag } from '@use-gesture/react'
import { useThree } from '@react-three/fiber'
import { useDispatch, useSelector } from 'react-redux';
import debounce from 'lodash.debounce';

import * as actionCreator from '../../../../../../action/index';
import { convertToAdjustedFeetInches } from '../../../../../../redux/reducers/utils';
import { makeTranslucent } from '../../../../../../helpers/building/building_config/componentConfig';
import { params, const_var } from '../../../../../../redux/reducers/reducer';
import { controls } from '../../../../../../redux/reducers/common/eventReducer';

import Wall from './Wall';
import DoorWindows from '../../../../DoorWindows';
import OutLineSection from './OutLineSection';
import { wallNameArrForValid } from '../../../../../../utils/Validation';
import { LimitValueOnWall } from '../../../../../../utils/GetCmpInfoOnWall';

const Storage = () => {
    const dispatch = useDispatch();
    const get = useThree((state) => state.get);
    const prevStorageLengthRef = useRef();
    const prevLeanLengthRef = useRef();
    const distance = const_var.controls?.getDistance([0, 0, 0]);
    const isActiveWallSubTab = useSelector(state => state.reducer.isActiveWallSubTab);
    const leanToTrussPosInfo = useSelector(state => state.reducer.leanToTrussPosInfo);
    const isResetBuilding = useSelector(state => state.reducer.isResetBuilding);
    
    const [isHovered, setIsHovered] = useState(false);
    const [isDragable, setIsDragable] = useState(true);
    const [position, setPosition] = useState(0);
    const [startPosition, setStartPosition] = useState(0);
    const [dragging, setDragging] = useState(false);

    const railWidth = 0.3;

    const legDistance = useMemo(() => {
        return (const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined) ? const_var.DistanceArr[params.p_b_t][params.p_r_s] : 5
    }, [const_var.DistanceArr, params.p_b_t, params.p_r_s,params.fourth_center_cost,const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined && const_var.DistanceArr[params.p_b_t][params.p_r_s]])
    
    const prevStorageLengthValue = prevStorageLengthRef.current || parseInt(params.add_storage_right);
    const prevLeanLengthValue = prevLeanLengthRef.current || params.leanR_p_d;
   
    const camPosZ = const_var.camera?.position?.z;

    let offset = 1
    if(camPosZ >= 0) offset = -1;
    else if(camPosZ < 0) offset = 1;

    const limit = useMemo(() => {
        return {
            min: 0,
            max: params.leanR_p_d - parseInt(params.add_storage_right)
        }
    }, [params.leanR_p_d, params.add_storage_right])
        
    const debounceForDragLean = debounce(() => {
        setTimeout(() => {
            setIsDragable(true)
            get().gl.domElement.style.cursor = 'auto'
            clearTimeout();
        }, [750])
    }, [750])

    const bind = useDrag(
        ({ down, delta, first, event, movement: [mx, my] }) => {
            
            if (controls.isCheckActiveTab === 'walls' && isActiveWallSubTab === 'right_lean_to' && const_var.isStorageMovementEnableForMfg) {
                event.stopPropagation();
                if (first) {
                    if (!params.is_translusant) makeTranslucent(null, null, params.is_translusant, const_var.scene, true, 'gable-right-lean-storage');
                    setStartPosition(position);
                }

                if (down === true) {
                    dispatch(actionCreator.updateEditIconVisiblity())
                    const_var.controls.enableRotate = false;
                    
                    if (isDragable) {
                        get().gl.domElement.style.cursor = 'move';
                        
                        const nextPosition = startPosition + (-mx * offset) * (distance / 1000);
                        if (nextPosition < limit.min) {
                            setPosition(limit.min)
                        } else if (nextPosition > limit.max) {
                            setPosition(limit.max)
                        } else {
                            setPosition(nextPosition);
                        } 
                        setDragging(true);
                    }
                } else {
                    if (!params.is_translusant) makeTranslucent(null, null, params.is_translusant, const_var.scene, false, 'gable-right-lean-storage');

                    const newPosition = leanToTrussPosInfo.rightLeanTo?.map(val => val - params.p_w / 2).reduce((prev, curr) => Math.abs(curr - position) < Math.abs(prev - position) ? curr : prev);
                    const_var.controls.enableRotate = true;
                    get().gl.domElement.style.cursor = 'auto';

                    let tempPosition = 0;
                    if (position < legDistance / 2) {
                        tempPosition = 0;
                    } else if(params.leanR_p_d - position - parseInt(params.add_storage_right) < legDistance / 2) {
                        tempPosition = params.leanR_p_d - parseInt(params.add_storage_right);
                    } else {
                        tempPosition = newPosition;
                    }
                                        
                    let isFindRight = false;
                    let isFindLeft = false;
                    const doorsArray = [...const_var.newDoorsArray]
                    const storageRightSideDoorsArr = doorsArray.filter(item => item.userData.wallName === 'G_R_L_R_S_W');
                    const cbRightSideDoorsArr = doorsArray.filter(item => item.userData.wallName === 'G_R_L_R_W');
                    const storageLeftSideDoorsArr = doorsArray.filter(item => item.userData.wallName === 'G_R_L_L_S_W');
                    const cbLeftSideDoorsArr = doorsArray.filter(item => item.userData.wallName === 'G_R_L_L_W');

                    if (storageRightSideDoorsArr.length > 0 && cbRightSideDoorsArr.length > 0) {
                        storageRightSideDoorsArr.forEach(item_st => {
                            const tempChangedDoorPosX = item_st.positionX - (tempPosition - startPosition);

                            cbRightSideDoorsArr.forEach(item_cb => {
                                if (Math.abs(item_cb.positionX - tempChangedDoorPosX) < item_cb.width / 2 + item_st.width / 2 + const_var.componentDistance &&
                                    Math.abs(item_cb.positionY - item_st.positionY) < item_cb.height / 2 + item_st.height / 2 + const_var.componentDistance)
                                {
                                    isFindRight = true;
                                }
                            })
                        })
                    }
                    if (storageLeftSideDoorsArr.length > 0 && cbLeftSideDoorsArr.length > 0) {
                        storageLeftSideDoorsArr.forEach(item_st => {
                            const tempChangedDoorPosX = item_st.positionX + (tempPosition - startPosition);

                            cbLeftSideDoorsArr.forEach(item_cb => {
                                if (Math.abs(item_cb.positionX - tempChangedDoorPosX) < item_cb.width / 2 + item_st.width / 2 + const_var.componentDistance &&
                                    Math.abs(item_cb.positionY - item_st.positionY) < item_cb.height / 2 + item_st.height / 2 + const_var.componentDistance)
                                {
                                    isFindLeft = true;
                                }
                            })
                        })
                    }

                    if (isFindRight || isFindLeft) {
                        dispatch(actionCreator.handleShowAlertBox("notAllowNewPosition"));
                        setPosition(startPosition)
                        setStartPosition(startPosition)
                    } else {
                        setPosition(tempPosition)
                        setStartPosition(tempPosition);
                        dispatch(actionCreator.updateRightLeanStoragePosition(tempPosition, startPosition, true))
                                      
                        const posOffset = params.rightLeanStoragePosition - startPosition;
                        const updatedNewDoorArr = const_var.newDoorsArray.map((item) => {
                            const item_limit_x = LimitValueOnWall("model", item.userData.compType, item.userData.wallName, item.width, item.height, item.positionY, false).limitX
                            if (item.userData.wallName === 'G_R_L_L_S_W') {
                                const newPosX = item_limit_x.min === item_limit_x.max ? item_limit_x.min : convertToAdjustedFeetInches(item.positionX + posOffset, item_limit_x.min, item_limit_x.max)
                                return {
                                    ...item,
                                    positionX: newPosX,
                                    minLimitX: item_limit_x.min,
                                    maxLimitX: item_limit_x.max
                                }
                            } else if (item.userData.wallName === 'G_R_L_R_S_W') {
                                const newPosX = item_limit_x.min === item_limit_x.max ? item_limit_x.min : convertToAdjustedFeetInches(item.positionX - posOffset, item_limit_x.min, item_limit_x.max)
                                return {
                                    ...item,
                                    positionX: newPosX,
                                    minLimitX: item_limit_x.min,
                                    maxLimitX: item_limit_x.max
                                }
                            }
                            return item;
                        })

                        if (JSON.stringify(const_var.newDoorsArray) !== JSON.stringify(updatedNewDoorArr)) {
                            dispatch(actionCreator.updateDoorWindowsArray(updatedNewDoorArr, true));
                        }

                        let newArray;
                        if(params.rightLeanStoragePosition === params.leanR_p_d - parseInt(params.add_storage_right)){         
                            if (const_var.newDoorsArray.find(item => item.userData.wallName === "G_R_L_F_W")) {
                                newArray = const_var.newDoorsArray.filter(item => item.userData.wallName !== "G_R_L_F_S_W")
                                dispatch(actionCreator.updateDoorWindowsArray(newArray, true));
                            } else if (const_var.newDoorsArray.find(item => item.userData.wallName === "G_R_L_F_S_W")) {
                                const_var.newDoorsArray.filter(item => item.userData.wallName === "G_R_L_F_S_W").map(item => item.userData.wallName = "G_R_L_F_W");
                                dispatch(actionCreator.updateDoorWindowsArray(const_var.newDoorsArray, true));
                            }
                        } else if(params.rightLeanStoragePosition === 0){       
                            if (const_var.newDoorsArray.find(item => item.userData.wallName === "G_R_L_B_W")) {
                                newArray = const_var.newDoorsArray.filter(item => item.userData.wallName !== "G_R_L_B_S_W")
                                dispatch(actionCreator.updateDoorWindowsArray(newArray, true));
                            } else if (const_var.newDoorsArray.find(item => item.userData.wallName === "G_R_L_B_S_W")) {
                                const_var.newDoorsArray.filter(item => item.userData.wallName === "G_R_L_B_S_W").map(item => item.userData.wallName = "G_R_L_B_W");
                                dispatch(actionCreator.updateDoorWindowsArray(const_var.newDoorsArray, true));
                            }
                        }
                    }
                    setDragging(false);
                    debounceForDragLean()
                }
            }
        },
    );

    // useMemo(() => {
    //     if(leanToTrussPosInfo.rightLeanTo.length !== 0){
    //         const newPosition = leanToTrussPosInfo.rightLeanTo.reduce((prev, curr) => Math.abs(curr - position) < Math.abs(prev - position) ? curr : prev);
    //         if(params.leanR_p_d - position - parseInt(params.add_storage_right) < legDistance / 2){
    //             setPosition(params.leanR_p_d - parseInt(params.add_storage_right))
    //             setStartPosition(params.leanR_p_d - parseInt(params.add_storage_right));
    //             dispatch(actionCreator.updateRightLeanStoragePosition(params.leanR_p_d - parseInt(params.add_storage_right), startPosition, true))
    //         }else if(position < legDistance / 2){
    //             setPosition(0);
    //             setStartPosition(0);
    //             dispatch(actionCreator.updateRightLeanStoragePosition(0, startPosition, true));
    //         } else{
    //             setPosition(newPosition)
    //             setStartPosition(newPosition);
    //             dispatch(actionCreator.updateRightLeanStoragePosition(newPosition, startPosition, true))
    //         }
    //     }
    // }, [params.leanR_p_d, leanToTrussPosInfo.rightLeanTo, params.add_storage_right]);

    useMemo(() => {
        // Store the previous storage size(add_storage_right) value
        prevStorageLengthRef.current = parseInt(params.add_storage_right);
        prevLeanLengthRef.current = params.leanR_p_d;
    
        if (prevStorageLengthValue >= params.leanR_p_d) {
            // Remove End Storage if the building length is smaller than storage size.
            dispatch(actionCreator.toggleAddUtilityCheckboxChangeForRight(true))
        } else {
            if (!dragging && (prevLeanLengthValue > params.leanR_p_d || prevStorageLengthValue < parseInt(params.add_storage_right))) {
                if (params.leanR_p_d - position - parseInt(params.add_storage_right) < 0) {
                    const newPosition = params.leanR_p_d - parseInt(params.add_storage_right);
                    setPosition(newPosition);
                    setStartPosition(newPosition)
                    dispatch(actionCreator.updateRightLeanStoragePosition(newPosition));

                    const_var.newDoorsArray.filter((e) => e.userData.wallName === 'G_R_L_L_S_W' || e.userData.wallName === 'G_R_L_R_S_W').forEach((item) => {
                        let newPositionX;
                        if(item.userData.wallName === 'G_R_L_L_S_W'){ 
                            newPositionX = item.positionX + ((prevLeanLengthValue - position - parseInt(params.add_storage_right)) - (prevLeanLengthValue - params.leanR_p_d));
                        } else {
                            newPositionX = item.positionX - ((prevLeanLengthValue - position - parseInt(params.add_storage_right)) - (prevLeanLengthValue - params.leanR_p_d));
                        }
                        dispatch(actionCreator.updateDoorWindowPosition(item.uniqueId, newPositionX))
                    });

                }

                const doorsArray = [...const_var.newDoorsArray]
                const storageRightSideDoorsArr = doorsArray.filter(item => item.userData.wallName === 'G_R_L_R_S_W');
                const cbRightSideDoorsArr = doorsArray.filter(item => item.userData.wallName === 'G_R_L_R_W');
                const storageLeftSideDoorsArr = doorsArray.filter(item => item.userData.wallName === 'G_R_L_L_S_W');
                const cbLeftSideDoorsArr = doorsArray.filter(item => item.userData.wallName === 'G_R_L_L_W');

                let updatedDoorsWindowsArr = doorsArray;
                if (storageRightSideDoorsArr.length > 0 && cbRightSideDoorsArr.length > 0) {
                    storageRightSideDoorsArr.forEach(item_st => {
                        cbRightSideDoorsArr.forEach(item_cb => {
                            if (Math.abs(item_cb.positionX - item_st.positionX) < item_cb.width / 2 + item_st.width / 2 + const_var.componentDistance &&
                                Math.abs(item_cb.positionY - item_st.positionY) < item_cb.height / 2 + item_st.height / 2 + const_var.componentDistance)
                            {
                                updatedDoorsWindowsArr = updatedDoorsWindowsArr.filter(item => item.uniqueId !== item_cb.uniqueId)
                            }
                        })
                    })
                }
                if (storageLeftSideDoorsArr.length > 0 && cbLeftSideDoorsArr.length > 0) {
                    storageLeftSideDoorsArr.forEach(item_st => {
                        cbLeftSideDoorsArr.forEach(item_cb => {
                            if (Math.abs(item_cb.positionX - item_st.positionX) < item_cb.width / 2 + item_st.width / 2 + const_var.componentDistance &&
                                Math.abs(item_cb.positionY - item_st.positionY) < item_cb.height / 2 + item_st.height / 2 + const_var.componentDistance)
                            {
                                updatedDoorsWindowsArr = updatedDoorsWindowsArr.filter(item => item.uniqueId !== item_cb.uniqueId)
                            }
                        })
                    })
                }
                dispatch(actionCreator.updateDoorWindowsArray(updatedDoorsWindowsArr, true));

                let newArray;
                if(params.rightLeanStoragePosition === params.leanR_p_d - parseInt(params.add_storage_right)){         
                    if (const_var.newDoorsArray.find(item => item.userData.wallName === "G_R_L_F_W")) {
                        newArray = const_var.newDoorsArray.filter(item => item.userData.wallName !== "G_R_L_F_S_W")
                        dispatch(actionCreator.updateDoorWindowsArray(newArray, true));
                    } else if (const_var.newDoorsArray.find(item => item.userData.wallName === "G_R_L_F_S_W")) {
                        const_var.newDoorsArray.filter(item => item.userData.wallName === "G_R_L_F_S_W").map(item => item.userData.wallName = "G_R_L_F_W");
                        dispatch(actionCreator.updateDoorWindowsArray(const_var.newDoorsArray, true));
                    }
                } else if(params.rightLeanStoragePosition === 0){       
                    if (const_var.newDoorsArray.find(item => item.userData.wallName === "G_R_L_B_W")) {
                        newArray = const_var.newDoorsArray.filter(item => item.userData.wallName !== "G_R_L_B_S_W")
                        dispatch(actionCreator.updateDoorWindowsArray(newArray, true));
                    } else if (const_var.newDoorsArray.find(item => item.userData.wallName === "G_R_L_B_S_W")) {
                        const_var.newDoorsArray.filter(item => item.userData.wallName === "G_R_L_B_S_W").map(item => item.userData.wallName = "G_R_L_B_W");
                        dispatch(actionCreator.updateDoorWindowsArray(const_var.newDoorsArray, true));
                    }
                }
            }
        }
    
    }, [params.leanR_p_d, params.add_storage_right, params.rightLeanStoragePosition]);

    useMemo(() => {
        if(!params.apiCallAfterEdit){
            setPosition(0);
            setStartPosition(0)
            dispatch(actionCreator.updateRightLeanStoragePosition(0));
        } else {
            setPosition(params.rightLeanStoragePosition);
            setStartPosition(params.rightLeanStoragePosition)
            dispatch(actionCreator.updateRightLeanStoragePosition(params.rightLeanStoragePosition));
        }
    }, [params.building_type_name, isResetBuilding])

    return (        
        <group 
            position={[position, 0, 0]}
            onPointerOver={(e) => {
                if(controls.isCheckActiveTab !== 'doorwindow'){
                    e.stopPropagation(); 
                    setIsHovered(true);
                }
            }}
            onPointerOut={() => setIsHovered(false)}
            {...bind()}
            name='gable-right-lean-storage'
        >
            <Wall />
            
            <group position={dragging ? undefined : [-position, 0, -params.leanR_p_pos]}>
                <DoorWindows section={'gable-right-lean-storage'} />
            </group>
            {controls.isCheckActiveTab === 'walls' && isActiveWallSubTab === 'right_lean_to' && const_var.isStorageMovementEnableForMfg && isHovered && <OutLineSection/>}
        </group>
    )
}

export default Storage